import { render, staticRenderFns } from "./SystemType.vue?vue&type=template&id=5afaa059&scoped=true&"
import script from "./SystemType.vue?vue&type=script&lang=js&"
export * from "./SystemType.vue?vue&type=script&lang=js&"
import style0 from "./SystemType.vue?vue&type=style&index=0&id=5afaa059&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afaa059",
  null
  
)

export default component.exports